// extracted by mini-css-extract-plugin
export default {"topPill":"pill__topPill-e1tCI","icon":"pill__icon-Ep3Xy"};